import { hasCreditLine, hasCreditModel } from 'helpers/businesses';

export const getMaxLimitAmount = (business, statistics) => {
    if (hasCreditModel(business) && hasCreditLine(business)) {
        return statistics.creditAvailable;
    }
    return statistics.availableToAddtoCards;
};
